import React, { isValidElement } from 'react'
import PropTypes from 'prop-types'
import { CardHeader, Grid, Icon } from '@mui/material'
import { isUndefined } from 'lodash'
import Action from 'components/action/Action'

const Title = ({
    title = '',
    subTitle = '',
    subtitleSize = 2,
    actions = [],
    icon,
    onClick,
    centerTitle = false,
}) => {
    const filteredActions = actions.filter(a => a.displayed || isUndefined(a.displayed))
    return (
        <Grid container spacing={2} alignItems='center'>
            <Grid size='grow'>
                <Grid
                    container
                    spacing={1}
                    alignItems='center'
                    onClick={onClick}
                    sx={{ cursor: onClick ? 'pointer' : 'default' }}
                >
                    {!!icon && (
                        <Grid size='auto'>
                            {isValidElement(icon) ? icon : <Icon>{icon}</Icon>}
                        </Grid>
                    )}
                    <Grid container size='grow' sx={{ justifyContent: centerTitle ? 'center' : undefined }} >
                        {isValidElement(title) ? title : (<span style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>{title}</span>)}
                    </Grid>
                </Grid>
            </Grid>
            {!!subTitle && (
                <Grid size={subTitle ? subtitleSize : 'auto'}>
                    {isValidElement(subTitle) ? subTitle : (<span style={{ fontSize: '1.4rem' }}>{subTitle}</span>)}
                </Grid>
            )}
            {filteredActions.length > 0 && (
                <Grid container size='auto' spacing={0.5}>
                    {filteredActions.map(action => (
                        <Grid key={actions.indexOf(action)} size='auto'>
                            {isValidElement(action) ? action : (<Action {...action} />)}
                        </Grid>
                    ))}
                </Grid>
            )}
        </Grid>
    )
}

Title.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    subtitleSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    onClick: PropTypes.func,
    actions: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.shape({
            icon: PropTypes.string,
            tooltip: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.element,
            ]),
            onClick: PropTypes.func,
            color: PropTypes.string,
            displayed: PropTypes.bool,
            'data-cy': PropTypes.string,
        }),
    ])),
    centerTitle: PropTypes.bool,
}

const CardTitle = ({
    title = '',
    subTitle = '',
    subtitleSize = 2,
    actions = [],
    color = '#FFF',
    icon,
    onClick,
    centerTitle = false,
}) => (
    <CardHeader
        title={<Title title={title} centerTitle={centerTitle} subTitle={subTitle} actions={actions} subtitleSize={subtitleSize} icon={icon} onClick={onClick} />}
        color={color}
        disableTypography
    />
)

CardTitle.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    subtitleSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    onClick: PropTypes.func,
    actions: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.shape({
            icon: PropTypes.string,
            tooltip: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.element,
            ]),
            onClick: PropTypes.func,
            color: PropTypes.string,
            displayed: PropTypes.bool,
            'data-cy': PropTypes.string,
        }),
    ])),
    color: PropTypes.string,
    bgColor: PropTypes.string,
    centerTitle: PropTypes.bool,
}

export { CardTitle }